function init_basic_tooltips() {

    //Initialise custom tooltips
    tippy('.tippy', {
        theme: 'light custom-tooltip',
        arrow: false,
        animateFill: false,
        animation: 'scale',
        maxWidth: 420,
        delay: [200, 0],
        distance: 20,
        touch: false
    });

    //Initialise custom image tooltips
    tippy('.tippy-image', {
        theme: 'light custom-tooltip',
        arrow: false,
        animateFill: false,
        animation: 'scale',
        delay: [200, 0],
        distance: 20,
        maxWidth: 'none',
        trigger: 'click',
        content: 'Loading...',
        onShow: function() {
            $('.custom-modal__overlay').fadeIn();
        },
        onHide: function() {
            $('.custom-modal__overlay').fadeOut();
        }
    });
}

function init_popovers() {

    $('.tippy-modal').each(function(i, e) {

        //Only init if we haven't yet
        if(e._tippy === undefined) {

            var id = $(e).attr('data-template');
            var $template = $('#' + id);

            tippy(e, {
                theme: 'light custom-modal',
                placement: 'top-start',
                arrow: false,
                animateFill: false,
                animation: 'scale',
                hideOnClick: true,
                interactive: true,
                maxWidth: 420,
                trigger: 'click',
                content: function(reference) {
                    if(reference.id === 'wastage-calc') {

                        var id = reference.getAttribute('data-template'),
                            $container = $('<div />'),
                            $linkedTemplate = $('#' + id),
                            $node = $linkedTemplate.clone();
                            $node.removeAttr('style');

                        //Replace our placeholder "REMOVE" ids
                        //This is so clicking labels in modal doesn't focus hidden cloneable template
                        $.each($node.find('label'), function(i, v) {
                            var original_id = $(this).attr('for');

                            if(original_id) {
                                var new_id = original_id.replace('_REMOVE', '');
                                var $input = $(this).closest('.row').find('#' + original_id);

                                $(this).attr('for', new_id);
                                if ($input) {
                                    $input.attr('id', new_id);
                                }
                            }

                        });

                        //Remove all no-touchy classes from selects
                        $node.find('select').removeClass('no-touchy');

                        $container.append($node);
                        return $container.html();

                    } else {
                        return $template[0];
                    }
                },
                onMount: function(obj) {
                    init_selects();
                    init_basic_tooltips();

                    if(obj.reference.id !== 'wastage-calc') {
                        $template.show();
                    }
                }
            });
        }
    });

    //Ajax share tippy modal
    tippy('.share-modal', {
        theme: 'light custom-modal',
        placement: 'bottom-end',
        arrow: false,
        animateFill: false,
        animation: 'scale',
        hideOnClick: true,
        interactive: true,
        maxWidth: 420,
        flipOnUpdate: true,
        trigger: 'click',
        popperOptions: {
            modifiers: {
                computeStyle: {
                    enabled: true,
                    fn: function (data) {
                        data.styles = Object.assign({}, data.styles, {
                            position: 'fixed',
                            left: ((window.innerWidth - data.popper.width) / 2) + 'px',
                            top: '50%',
                            transform: 'translateY(-50%)'
                        });

                        return data;
                    }
                }
            }
        },
        content: '<span class="far fa-spinner fa-spin inline--big"></span>',
        onShow: function(instance) {
            $('.custom-modal__overlay').fadeIn();

            //Build data object
            var $el = $(instance.reference);
            var data = {};
            data.context = $el.data('context');
            data.action = $el.data('action');
            data.parameters = $el.data('parameters');

            if (instance.state.ajax === undefined) {
                instance.state.ajax = {
                    isFetching: false,
                    canFetch: true
                }
            }

            var scale = get_scale();
            var querystring = '';

            if(scale) {
                querystring = '?scale=' + scale;
            }

            var $share_url = $(instance.popper).find('#share_url');
            if($share_url.length) {
                $share_url.val($share_url.data('original') + '?scale=' + scale);
            }

            if (instance.state.ajax.isFetching || !instance.state.ajax.canFetch) {
                return;
            }

            ajax_call('get', '/admin/share/add/' + data.context + '/' + data.action + '/' + data.parameters + querystring, {}, function(resp) {
                instance.state.ajax.isFetching = false;
                instance.state.ajax.canFetch = false;
                instance.setContent(resp);
            });

        },
        onHide: function() {
            $('.custom-modal__overlay').fadeOut();
        }
    });

    //Close modal button
    //NB: This will close all tippy-modals that are opened currently
    $body.on('click', '.close-tippy-modal', function (e) {
        tippy.hideAll();
    });

}

$(function() {
    //Initialise custom tooltips
    init_basic_tooltips();
    init_popovers();
});
